import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { Seo } from "./components/Seo";
import { ChatWidget } from "./components/ChatWidget";
import { StickyPartnerCta } from "./components/PartnerBanner";
import Marketplace from "./pages/Marketplace";
import RestaurantDetail from "./pages/RestaurantDetail";
import MembershipPage from "./pages/MembershipPage";
import CustomerLogin from "./pages/CustomerLogin";
import RestaurantAuth from "./pages/RestaurantAuth";
import RestaurantDashboard from "./pages/RestaurantDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import PartnersPage from "./pages/PartnersPage";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ContactPage from "./pages/ContactPage";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Marketplace />} />
      <Route path="/restaurant/:id" element={<RestaurantDetail />} />
      <Route path="/membre" element={<MembershipPage />} />
      <Route path="/login" element={<CustomerLogin />} />
      <Route path="/restaurant" element={<RestaurantAuth />} />
      <Route path="/dashboard" element={<RestaurantDashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/partenaires" element={<PartnersPage />} />
      <Route path="/partners" element={<PartnersPage />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/contact" element={<ContactPage />} />
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <AppRouter />
            <ChatWidget />
            <StickyPartnerCta />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
